/* eslint-disable react/no-unescaped-entities */
import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import '../../view-home.css';
import SeminarEvent from '../../../../types/communication/seminarEvent';
import FilingDeadline from '../../../../types/communication/filingDeadline';
import { Link, Stack } from '@mui/material';

const LatestEvents = (): JSX.Element => {
  const [seminars, setSeminars] = useState<SeminarEvent[]>();
  const [filingDeadlines, setFilingDeadlines] = useState<FilingDeadline[]>();

  useEffect(() => {
    getUpcomingEvents();
    getFilingDeadlines();
  }, [])

  const getUpcomingEvents = async () => {
    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/events/upcoming/next4`)
      .then(result => result.json())
      .then(result => {
        setSeminars(result)
      });

    }catch(error){
      //add error handling
    }
    
  }

  const getFilingDeadlines = async () => {
    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/filingDeadlines`)
      .then(result => result.json())
      .then(result => {
        setFilingDeadlines(result)
      });

    }catch(error){
      console.error('Uncaught Error:', error);
    }
    
  }

  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      <Stack marginBottom={3}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
          }}
        >
          Upcoming Seminars
        </Typography>
        <Typography display={"flex"} justifyContent={"flex-end"} component={Link} variant='subtitle2' underline='hover' href={"https://ocpfreporter.us/SeminarRegistration/"} marginTop={1}>Register Seminars</Typography>
      </Stack>
      <Grid container spacing={2} className="seminarsContainer" marginBottom={2}>
        {seminars?.map((item, i) => (
          <Grid key={i} size={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              display={'flex'}
              flexDirection={'row'}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Box
                sx={{
                  width: '20%',
                }}
              >
               <div className="calendarDate">
                  <em>{new Date(item.date).toLocaleDateString('default', { weekday: 'short' })}</em>
                  <strong>{item.dateDisplayMonth} {item.dateDisplayYear}</strong>
                  <span>{item.dateDisplayDay}</span>
               </div>
              </Box>
              <CardContent
                sx={{ 
                  padding: 0, 
                  width: '80%',
                  '&:last-child': { paddingBottom: 1 } 
                }}
              >
                <Typography variant={'body2'} fontWeight={600}>{item.startTime} {item.title}</Typography>
                <Box marginY={1 / 4}>
                  <Typography
                    variant={'body2'}
                    color={'text.primary'}
                    component={'i'}
                  >
                    {item.description}
                  </Typography>
                </Box>
                <Button size="small" component={Link} href={`https://ocpfreporter.us/SeminarRegistration/?seminarEventId=${item.id}`} underline="none">Register</Button>
              </CardContent>
            </Box>
          </Grid>
        ))}
          <Grid size={12} display={'flex'} justifyContent={'flex-end'}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              component={Link}
              href='/Publications/EducationMultimedia'
            >
              View Seminar Calendar
            </Button>
          </Grid>
      </Grid>
      <Divider />
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          marginBottom: 3,
          marginTop:2
        }}
      >
        Upcoming Filing Deadlines
      </Typography>
      <Grid container spacing={2} className="filingDeadlinesContainer">
        {/*Temporary Public Finance Special Request*/}
        {/* <Grid size={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              display={'flex'}
              flexDirection={'row'}
              sx={{ 
                backgroundImage: 'none', 
                bgcolor: 'transparent' ,
                marginBottom: 1.5
              }}
            >
              <Box
                sx={{
                  width: '20%',
                }}
              >
               <div className="calendarDate">
                  <em>Tue</em>
                  <strong>Jun 2026</strong>
                  <span>2</span>
               </div>
              </Box>
              <CardContent
                sx={{ 
                  padding: 0, 
                  width: '80%',
                  '&:last-child': { paddingBottom: 1 } 
                }}
              >
                <Typography variant={'body2'} fontWeight={600}><Link href="https://ocpf2.blob.core.windows.net/pdf/forms/Form CPFA 20 (2026).pdf" target="_blank">Form CPFA 20</Link>: Statement on Campaign Expenditure Limits</Typography>
                <Box marginY={1 / 4}>
                  <Typography
                    variant={'body2'}
                    color={'text.primary'}
                    component={'i'}
                  >
                    Required only for statewide candidates enrolled in a political party
                  </Typography>
                </Box>
              </CardContent>
            </Box>
        </Grid> */}
        {filingDeadlines?.map((item, i) => (
          <Grid key={i} size={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              display={'flex'}
              flexDirection={'row'}
              sx={{ 
                backgroundImage: 'none', 
                bgcolor: 'transparent' ,
                marginBottom: 1.5
              }}
            >
              <Box
                sx={{
                  width: '20%',
                }}
              >
               <div className="calendarDate">
                  <em>{new Date(item.deadlineDisplay).toLocaleDateString('default', { weekday: 'short' })}</em>
                  <strong>{item.dateDisplayMonth} {item.dateDisplayYear}</strong>
                  <span>{item.dateDisplayDay}</span>
               </div>
              </Box>
              <CardContent
                sx={{ 
                  padding: 0, 
                  width: '80%',
                  '&:last-child': { paddingBottom: 1 } 
                }}
              >
                <Typography variant={'body2'} fontWeight={600}>{item.filingPeriodTypeDescription} Reports Due</Typography>
                <Box marginY={1 / 4}>
                  <Typography
                    variant={'body2'}
                    color={'text.primary'}
                    component={'i'}
                  >
                    {item.description}
                  </Typography>
                </Box>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LatestEvents;
